import React from "react";


class BtnConsulter extends React.Component {
    constructor(props) {
      super(props);
      this.btnClickedHandler = this.btnClickedHandler.bind(this);
    }
    btnClickedHandler() {
     this.props.clicked(this.props.value);
    }
    render() {
      return (
        <button className='ButtonGestionUtilisateur BGUGreen' onClick={this.btnClickedHandler}> Consulter </button>
      )
    }
  }
export default BtnConsulter